import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { AppStore } from "../../../..";
import { AuthDTO } from "../../../../auth/models/dto";
import {
  Fetchable,
  isFetchableSuccess,
} from "../../../../common/fetchable/helpers";
import { FieldHook, RenderFuncProps } from "../common";
import { AuthenticatedSourceWallet } from "./authenticated";
import { useSchema } from "./common";
import { UnauthenticatedSourceWallet } from "./unauthenticated";

const Elem: FC<RenderFuncProps> = (props) => {
  const login = useSelector<AppStore, Fetchable<AuthDTO.Responses.Login.T>>(
    (state) => state.auth.login
  );

  const hasQueryParams = useMemo(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.has("address") || urlSearchParams.has("chain");
  }, [window.location.search]);

  return isFetchableSuccess(login) && !hasQueryParams ? (
    <AuthenticatedSourceWallet {...props} />
  ) : (
    <UnauthenticatedSourceWallet {...props} />
  );
};

export const useSourceWalletField: FieldHook = () => {
  const schema = useSchema();

  return useMemo(
    () => ({
      schema,
      elem: Elem,
      cryptoField: true,
    }),
    [schema]
  );
};
